import React from "react";
import { TouchableOpacity } from "../../components/Buttons";
import { Text } from "../../components/Text";
import { linkStyles as styles } from "./styles";

interface LinkProps {
  linkTitle: string;
  onPress: () => void;
}

const TextLink: React.FC<LinkProps> = ({ linkTitle, onPress }) => {
  return (
    <TouchableOpacity onPress={onPress}>
      <Text style={styles.linkLabel}>{linkTitle}</Text>
    </TouchableOpacity>
  );
};

export default TextLink;
